
export const Cities = [
    {
        name: 'Atlanta',
        url: '/primary-care-doctors/atlanta-218712pm',
    },
    {
        name: 'Austin',
        url: '/primary-care-doctors/austin-221873pm',
    },
    {
        name: 'Chicago',
        url: '/primary-care-doctors/chicago-210499pm',
    },
    {
        name: 'Columbus',
        url: '/primary-care-doctors/columbus-242836pm',
    },
    {
        name: 'Dallas',
        url: '/primary-care-doctors/dallas-tx-211240pm',
    },
    {
        name: 'Denver',
        url: '/primary-care-doctors/denver-228319pm',
    },
    {
        name: 'Houston',
        url: '/primary-care-doctors/houston-215108pm',
    },
    {
        name: 'Jersey City',
        url: '/primary-care-doctors/jersey-city-10956pm',
    },
    {
        name: 'Los Angeles',
        url: '/primary-care-doctors/los-angeles-13122pm',
    },
    {
        name: 'New York',
        url: '/primary-care-doctors/new-york-46063pm',
    },
    {
        name: 'Philadelphia',
        url: '/primary-care-doctors/philadelphia-216871pm',
    },
    {
        name: 'Phoenix',
        url: '/primary-care-doctors/phoenix-220419pm',
    },
    {
        name: 'San Antonio',
        url: '/primary-care-doctors/san-antonio-225141pm',
    },
    {
        name: 'San Diego',
        url: '/primary-care-doctors/san-diego-223791pm',
    },
    {
        name: 'San Francisco',
        url: '/primary-care-doctors/san-francisco-6785pm',
    },
    {
        name: 'Washington, DC',
        url: '/primary-care-doctors/washington-34993pm',
    },
    {
        name: 'view all',
        url: '/locations',
    },
];

export const Specialties = [
    {
        name: 'Allergist',
        url: '/allergists',
    },
    {
        name: 'Cardiologist',
        url: '/cardiologists',
    },
    {
        name: 'Chiropractor',
        url: '/chiropractors',
    },
    {
        name: 'Dentist',
        url: '/dentists',
    },
    {
        name: 'Dermatologist',
        url: '/dermatologists',
    },
    {
        name: 'Ear, Nose & Throat Doctor',
        url: '/ear-nose-throat-doctors',
    },
    {
        name: 'Gastroenterologist',
        url: '/gastroenterologists',
    },
    {
        name: 'OB-GYN',
        url: '/obgyns',
    },
    {
        name: 'Opthalmologist',
        url: '/ophthalmologists',
    },
    {
        name: 'Optometrist',
        url: '/optometrists',
    },
    {
        name: 'Orthopedic Surgeon',
        url: '/orthopedic-surgeons',
    },
    {
        name: 'Pediatrician',
        url: '/pediatricians',
    },
    {
        name: 'Podiatrist',
        url: '/podiatrists',
    },
    {
        name: 'Primary Care Doctor',
        url: '/primary-care-doctors',
    },
    {
        name: 'Psychiatrist',
        url: '/psychiatrists',
    },
    {
        name: 'Urologist',
        url: '/urologists',
    },
    {
        name: 'view all',
        url: '/morespecialties',
    },
];

export const Insurances = [
    {
        name: 'Aetna',
        url: '/primary-care-doctors/aetna-300m',
    },
    {
        name: 'Anthem Blue Cross Blue Shield',
        url: '/primary-care-doctors/anthem-blue-cross-blue-shield-324m',
    },
    {
        name: 'Blue Cross Blue Shield',
        url: '/primary-care-doctors/blue-cross-blue-shield-304m',
    },
    {
        name: 'Cigna',
        url: '/primary-care-doctors/cigna-307m',
    },
    {
        name: 'EmblemHealth (GHI)',
        url: '/primary-care-doctors/emblemhealth-ghi-338m',
    },
    {
        name: 'EmblemHealth (HIP)',
        url: '/primary-care-doctors/emblemhealth-hip-337m',
    },
    {
        name: 'Empire Blue Cross Blue Shield',
        url: '/primary-care-doctors/empire-blue-cross-blue-shield-336m',
    },
    {
        name: 'UnitedHealthcare',
        url: '/primary-care-doctors/unitedhealthcare-323m',
    },
    {
        name: 'UnitedHealthcare Oxford',
        url: '/primary-care-doctors/unitedhealthcare-oxford-330m',
    },
    {
        name: 'view all',
        url: '/insurances',
    },
];

export const AdditionalFilters = [
    {
        name: 'Name',
        url: 'directory',
    },
    {
        name: 'Practice',
        url: 'practicedirectory',
    },
    {
        name: 'Procedure',
        url: 'procedures',
    },
    {
        name: 'Reviews',
        url: 'doctor-reviews',
    },
    {
        name: 'Hospital',
        url: 'hospital-directory',
    },
    {
        name: 'Language',
        url: 'languages',
    },
];
